import React, { useEffect } from 'react'
import { Route, useSearchParams } from 'react-router'
import Loader from '../base/components/loader/loader'

const AutoLogin = () => {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const token = searchParams.get('token')
    if (!token) return
    localStorage.setItem('user', JSON.stringify({ token, loggedIn: true }))
    window.location.replace('/dashboard')
  }, [])

  return <Loader />
}

const NotFound = () => <div>404 Not Found</div>

const autoLoginRoutes = (
  <Route
    path='auto-login'
    Component={process.env.NODE_ENV === 'production' ? NotFound : AutoLogin}
  />
)

export default autoLoginRoutes
